export const foldersKeys = {
  all: () => ['FOLDERS'] as const,
  grouped: (getShared: boolean) => ['FOLDERS', getShared] as const,
};
